"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _Platform = _interopRequireDefault(require("react-native-web/dist/cjs/exports/Platform"));
var _useSafeLayoutEffect = _interopRequireDefault(require("../utils/useSafeLayoutEffect"));
var _StackWrapBox = _interopRequireDefault(require("./StackWrapBox"));
var _StackWrapGap = _interopRequireDefault(require("./StackWrapGap"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
// In Jest/CI/SSR, global CSS isn't always available and doesn't always have .supports method
const cssSupports = (property, value) => _Platform.default.OS === 'web' && typeof window !== 'undefined' && typeof window.CSS?.supports === 'function' && window.CSS.supports(property, value);

// CSS.supports needs an example of the type of value you intend to use.
// Will be an integer appended `px` after hooks and JSX styles are resolved.
const exampleGapValue = '1px';

/**
 * StackWrap is an alternative to StackView where the spaced items are allowed to wrap.
 *
 * As well as providing space between the items, StackWrap provides `gap` space between
 * wrapped lines of items. By default, this `gap` is the same as the gap between spaced items.
 * If a different spacing is desired between wrapped lines, pass a spacing value to the `gap` prop.
 */
const StackWrap = /*#__PURE__*/_react.default.forwardRef((props, ref) => {
  const [canUseCSSGap, setCanUseCSSGap] = _react.default.useState(false);
  const {
    space
  } = props;
  // Don't apply separate gap if `null` or `undefined`, so can be unset in Storybook etc
  const gap = props.gap ?? space;
  const gapEqualsSpace = gap === space;

  // If possible, use the cleaner implementation that applies CSS `gap` styles to the container,
  // preserving direct parent-child relationships between the container and each item, which
  // can result in clearer descriptions on some screen readers (e.g. radio "X of Y" on MacOS).
  // Else, use the fallback implementation which renders a `Box` component around each child.
  const Component = canUseCSSGap ? _StackWrapGap.default : _StackWrapBox.default;
  // In SSR, the type of implementation must match the server during hydration, but
  // the server can't know if gap is supported, so never use it until after hydration.
  (0, _useSafeLayoutEffect.default)(() => {
    setCanUseCSSGap(gapEqualsSpace && cssSupports('gap', exampleGapValue));
  }, [gapEqualsSpace]);
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(Component, {
    ref: ref,
    ...props
  });
});
StackWrap.displayName = 'StackWrap';
StackWrap.propTypes = _StackWrapBox.default.propTypes;
var _default = exports.default = StackWrap;